import cn from "classnames";

import { Blocks } from "@/components/blocks/blocks.component";

import { brown } from "@/app/font";

/** Text Component */
export const Text = ({
  variant,
  children,
  className,
  component,
  loading,
  loadingLines,
  loadingClassName,
  role,
  id,
  ...rest
}: TextProps) => {
  const Component = component || "div";
  return (
    <Component
      data-testid="text"
      className={cn(
        {
          [`${brown.className} pre-header-lg`]: variant === "preHeaderLg",
          [`${brown.className} pre-header-md`]: variant === "preHeaderMd",
          [`${brown.className} pre-header-sm`]: variant === "preHeaderSm",
          [`${brown.className} headline-3 lg:headline-1`]: variant === "h1",
          [`${brown.className} headline-3 lg:headline-2`]: variant === "h2",
          [`${brown.className} headline-3`]: variant === "h3",
          [`${brown.className} headline-4`]: variant === "h4",
          [`${brown.className} headline-5`]: variant === "h5",
          [`${brown.className} headline-6`]: variant === "h6",
          [`${brown.className} subtitle-1`]: variant === "subtitle1",
          [`${brown.className} subtitle-2`]: variant === "subtitle2",
          "body-1": variant === "body1",
          "body-2": variant === "body2",
          [`${brown.className} body-3`]: variant === "body3",
          "body-4": variant === "body4",
          "body-5": variant === "body5",
          "body-6": variant === "body6",
          legal: variant === "legal",
          chips: variant === "chips",
        },
        className,
      )}
      role={role}
      id={id}
      {...rest}>
      {loading ? (
        <Blocks blocks={loadingLines} className={loadingClassName} />
      ) : (
        children
      )}
    </Component>
  );
};
export type TextProps = {
  variant?:
    | "preHeaderLg"
    | "preHeaderMd"
    | "preHeaderSm"
    | "h1"
    | "h2"
    | "h3"
    | "h4"
    | "h5"
    | "h6"
    | "subtitle1"
    | "subtitle2"
    | "body1"
    | "body2"
    | "body3"
    | "body4"
    | "body5"
    | "body6"
    | "legal"
    | "chips";
  // Used to change the rendered HTML tag ex h1
  component?: React.ElementType;
  children?: React.ReactNode;
  className?: string;
  loading?: boolean;
  loadingLines?: number;
  loadingClassName?: string;
  role?: string;
  id?: string;
};
